import React from 'react'
import Portfolio from './Portfolio'
import Portfolio2 from './Portfolio2'
import PremiumPortfolio from './PremiumPortfolio'
import './index.css'

function App() {
  return (
    <div className="App">
      {/* <Portfolio /> */}
      <PremiumPortfolio />
      {/* <Portfolio2 /> */}
    </div>
  )
}


export default App
